import img1 from "../../image/Image _ Page/Service_popup/CyberSecurity Solution-main.jpeg";
import img2 from "../../image/Image _ Page/Service_popup/CyberSecurity Solution-1.jpeg";
import img3 from "../../image/Image _ Page/Service_popup/CyberSecurity Solution-2.jpeg";
import "../../Components/style/cyber.css";
import {
  FaShieldAlt,
  FaDesktop,
  FaCode,
  FaNetworkWired,
  FaVideo,
  FaFingerprint,
  FaUserTie,
  FaClock,
  FaToolbox,
  FaTools,

} from "react-icons/fa";

// Blue/white icon-card data for the "solution-card" section.
const SOLUTION_CARDS = [
  {
    icon: <FaShieldAlt size={20} />,
    title: "Data Security",
    desc: "Protect sensitive data with encryption, access controls, and breach prevention measures.",
  },
  {
    icon: <FaDesktop size={20} />,
    title: "Endpoint Security",
    desc: "Safeguard devices from malware, ransomware, and phishing attacks.",
  },
  {
    icon: <FaCode size={20} />,
    title: "Application Security",
    desc: "Secure web and mobile applications against sophisticated threats.",
  },
  {
    icon: <FaNetworkWired size={20} />,
    title: "Network Security",
    desc: "Implement firewalls, intrusion detection systems, and secure VPNs.",
  },
  {
    icon: <FaNetworkWired size={20} />,
    title: "Incident Response",
    desc: "Rapidly detect and respond to security incidents to minimize impact.",
  },
  {
    icon: <FaVideo size={20} />,
    title: "Video Surveillance & Monitoring",
    desc: "Real-time monitoring solutions to enhance physical security.",
  },
  {
    icon: <FaFingerprint size={20} />,
    title: "Identity & Access Management",
    desc: "Ensure only authorized personnel access critical systems and data.",
  },
];

const Cyber = () => {
  return (
    <div>
      <div style={{ position: "relative", width: "100%", height: "60vh" }}>
        {/* Image */}
        <img
          src={img1}
          alt="Inner Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          
          }}
        />

        {/* Centered Text */}
        <h2
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "3rem",
            fontWeight: "bold",
            textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)",
          }}
        >
          {/* Secure you Data */}
        </h2>
      </div>

      <div className="row align-items-center">
        <div className="col-lg-6">
          <div className="position-relative">
            <div className="ttm_single_image-wrapper text-sm-center">
              <img
                className="imagestyle"
                src={img2}
                title="single-img-ten"
                width="100%"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="res-991-mt-30">
            <div className="section-title with-desc clearfix">
              <div className="title-header">
                <h5>Security Solutions</h5>
                <h2 className="title">
                Shield Your Business with Cutting-Edge 
                <span> Security Solutions</span>
                </h2>
              </div>
              <div className="title-desc">
                <p>
                In a world of increasing cyber threats, Emicron Techsolutions provides comprehensive security services to protect your business.
                </p>
                <p>
                We utilize advanced technologies and industry best practices to deliver customized security solutions tailored to your needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ============ SOLUTION CARDS (blue/white icon-card grid, 3 per row) ============ */}
      <section style={{ padding: "60px 40px", background: "#F3F6FC" }}>
        <style>{`
          @media (max-width: 900px) {
            .orryx-cyber-solution-grid { grid-template-columns: 1fr 1fr !important; }
          }
          @media (max-width: 560px) {
            .orryx-cyber-solution-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            className="orryx-cyber-solution-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {SOLUTION_CARDS.map((card) => (
              <div
                key={card.title}
                style={{
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "26px",
                  boxShadow: "0 4px 16px rgba(15,23,42,0.05)",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "10px",
                    background: "#DCE6FB",
                    color: "#2563EB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  {card.icon}
                </div>
                <h5 style={{ fontSize: "16px", fontWeight: 700, margin: 0, marginBottom: "8px", color: "#111827" }}>
                  {card.title}
                </h5>
                <p style={{ fontSize: "13.5px", color: "#6B7280", lineHeight: 1.6, margin: 0, marginBottom: "14px" }}>
                  {card.desc}
                </p>
                <span style={{ color: "#2563EB", fontWeight: 600, fontSize: "13px" }}>
                  Read More →
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="quality">
              <div className="container">
                <div className="quality-content">
                  <div className="para">
                    <p>Ensuring Exceptional Quality In Security Solutions</p>
                  </div>
                  <div className="quaity-head">
                    <h2>
                      Our Commitment to Delivering Reliable and Secure Solutions
                    </h2>
                  </div>
                  <ul className="list-item" style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "16px" }}>
                    <li>
                      <div
                        className="list-box"
                        style={{
                          background: "#fff",
                          borderRadius: "14px",
                          boxShadow: "0 4px 16px rgba(15,23,42,0.06)",
                          padding: "22px 26px",
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        <div className="list-icon" style={{ flexShrink: 0 }}>
                          <FaUserTie size={36} color="#007bff" />
                        </div>
                        <div style={{ flexShrink: 0, width: "200px" }}>
                          <h4 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#111827" }}>
                            Proven Expertise
                          </h4>
                        </div>
                        <div className="list-para">
                          <p style={{ margin: 0, color: "#6B7280", fontSize: "14px", lineHeight: 1.6 }}>
                            Trusted by businesses and startups for robust security solutions.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="list-box"
                        style={{
                          background: "#fff",
                          borderRadius: "14px",
                          boxShadow: "0 4px 16px rgba(15,23,42,0.06)",
                          padding: "22px 26px",
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        <div className="list-icon" style={{ flexShrink: 0 }}>
                          <FaTools size={36} color="Red" />
                        </div>
                        <div style={{ flexShrink: 0, width: "200px" }}>
                          <h4 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#111827" }}>
                            Advanced Security Tools
                          </h4>
                        </div>
                        <div className="list-para">
                          <p style={{ margin: 0, color: "#6B7280", fontSize: "14px", lineHeight: 1.6 }}>
                            Leverage AI-driven tools and analytics to stay ahead of threats.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="list-box"
                        style={{
                          background: "#fff",
                          borderRadius: "14px",
                          boxShadow: "0 4px 16px rgba(15,23,42,0.06)",
                          padding: "22px 26px",
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        <div className="list-icon" style={{ flexShrink: 0 }}>
                          <FaToolbox size={36} color="Green" />
                        </div>
                        <div style={{ flexShrink: 0, width: "200px" }}>
                          <h4 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#111827" }}>
                            Regulatory Compliance
                          </h4>
                        </div>
                        <div className="list-para">
                          <p style={{ margin: 0, color: "#6B7280", fontSize: "14px", lineHeight: 1.6 }}>
                            Ensure compliance with industry regulations and standards.
                          </p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="list-box"
                        style={{
                          background: "#fff",
                          borderRadius: "14px",
                          boxShadow: "0 4px 16px rgba(15,23,42,0.06)",
                          padding: "22px 26px",
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        <div className="list-icon" style={{ flexShrink: 0 }}>
                          <FaClock size={36} color="Orange" />
                        </div>
                        <div style={{ flexShrink: 0, width: "200px" }}>
                          <h4 style={{ margin: 0, fontSize: "17px", fontWeight: 700, color: "#111827" }}>
                            Round-the-Clock Protection
                          </h4>
                        </div>
                        <div className="list-para">
                          <p style={{ margin: 0, color: "#6B7280", fontSize: "14px", lineHeight: 1.6 }}>
                            24/7 security monitoring and support to safeguard your business.
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
      
                <div className="quality-image">
                
                </div>
              </div>
            </section>
    </div>
  );
};

export default Cyber;
